import { SxProps, Theme } from "@mui/material/styles";
import { gris3 } from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.modifyStatuts": {
      "& h6": {
        textTransform: "uppercase",
      },
      "& .MuiDialog-paperWidthXs": {
        background: gris3,
      },
      "& .MuiFormControl-root": {
        marginBottom: 1,
      },
      "& .MuiInputBase-root": {
        background: "white",
      },
    },
    "& .actionButton": {
      padding: "0 24px 24px 24px",
      "& button": {
        marginLeft: 3,
      },
    },
  },
];

export default styles;
